module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tangeche tangehce-template-amy-or-souche"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "carsContent"
  }, [_c('div', {
    staticClass: "hotNewCars"
  }, _vm._l((_vm.carListComputed), function(item) {
    return _c('div', {
      staticClass: "car-item-container"
    }, [_c('a', {
      attrs: {
        "href": '/car/' + item.id
      }
    }, [_c("CarItem", {
      tag: "div",
      staticClass: "car-item",
      class: ['line-height-level-' + _vm.lineHeightLevel],
      attrs: {
        "data": item
      }
    })])])
  }))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "moduleTitle"
  }, [_vm._v("最新车辆"), _c('a', {
    staticClass: "more",
    attrs: {
      "href": "/buy.htm",
      "target": "_blank"
    }
  }, [_vm._v("更多>>")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5637d3be!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/newcar/components/TemplateCrystalOrSouche.vue
// module id = 107
// module chunks = 2 3 4 5